import { MONOGRAM, WORDMARK } from "@sakani/brand/logo";

/** The Sekani wordmark. Inherits the surrounding text colour, so it flips with the theme. */
export function Logo({ height = 40, mono = false, label = "Sekani" }: { height?: number; mono?: boolean; label?: string }) {
  const g = mono ? MONOGRAM : WORDMARK;
  return (
    <svg className="logo" role="img" aria-label={label} viewBox={`0 0 ${g.w} ${g.h}`} height={height} width={(height * g.w) / g.h} fill="currentColor">
      <path fillRule="evenodd" d={g.d} />
    </svg>
  );
}
